import type { ReactNode } from 'react';

import { DrawerHeader as DesignSystemDrawerHeader } from 'design-system';
import { LayoutDashboard } from 'lucide-react';

export const DrawerHeader = ({
  before,
  title,
  buttons
}: {
  before?: ReactNode;
  title: string;
  buttons: ReactNode;
}) => (
  <DesignSystemDrawerHeader>
    {before}
    <div className={`flex flex-1 items-center ${before ? 'pl-0' : 'pl-6'}`}>
      <h2 className='flex h-15 items-center gap-4 font-heading text-2xl font-semibold [&_svg]:size-8'>
        <LayoutDashboard aria-hidden='true' />
        {title}
      </h2>
    </div>
    {buttons != null && <div className='flex gap-0.5'>{buttons}</div>}
  </DesignSystemDrawerHeader>
);
